import { GridIcon } from '../icons/GridIcon'
import { ListIcon } from '../icons/ListIcon'

/* ─── Grid / list view toggle for the MCP product overviews ───
   Shared by MCP Config (/mambu-mcp) and MCP Analytics (/mcp-analytics). The
   prototype gives each surface its own button class (`mcpconn-view-btn`,
   `mcpobs-view-btn`) while the styling is entirely inline, so the class comes
   in as a prop and no CSS is attached to either name.
   Prototype: agent-studio.html:5755-5757 (analytics), :5449-5451 (config). */

export type ProductView = 'grid' | 'list'

function ViewToggleBtn({
  active,
  title,
  onClick,
  children,
  btnClassName,
  borderLeft = false,
}: {
  active: boolean
  title: string
  onClick: () => void
  children: React.ReactNode
  btnClassName: string
  borderLeft?: boolean
}) {
  return (
    <button
      type="button"
      title={title}
      aria-label={title}
      aria-pressed={active}
      onClick={onClick}
      className={`${btnClassName}${active ? ' active' : ''}`}
      style={{
        padding: '6px 10px',
        border: 'none',
        borderLeft: borderLeft ? '1px solid var(--border)' : 'none',
        borderRadius: 0,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {children}
    </button>
  )
}

export interface ProductViewToggleProps {
  view: ProductView
  onChange: (next: ProductView) => void
  gridLabel: string
  listLabel: string
  /** Per-surface button class from the prototype, e.g. `mcpconn-view-btn` / `mcpobs-view-btn`. */
  btnClassName: string
}

export function ProductViewToggle({
  view,
  onChange,
  gridLabel,
  listLabel,
  btnClassName,
}: ProductViewToggleProps) {
  return (
    <div style={{ display: 'flex', border: '1px solid var(--border)', borderRadius: 6, overflow: 'hidden' }}>
      <ViewToggleBtn
        active={view === 'list'}
        title={listLabel}
        onClick={() => onChange('list')}
        btnClassName={btnClassName}
      >
        <ListIcon />
      </ViewToggleBtn>
      <ViewToggleBtn
        active={view === 'grid'}
        title={gridLabel}
        onClick={() => onChange('grid')}
        btnClassName={btnClassName}
        borderLeft
      >
        <GridIcon />
      </ViewToggleBtn>
    </div>
  )
}
